var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "m-portlet" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-portlet__body" },
        [
          _c(
            "el-form",
            {
              ref: "offerTemplate",
              attrs: {
                rules: _vm.rules,
                model: _vm.offerTemplate,
                "label-width": "200px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.offerTemplate.name,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplate, "name", $$v)
                      },
                      expression: "offerTemplate.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "project_type_id", label: "Projekt Kategorie" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Bitte wählen" },
                      model: {
                        value: _vm.offerTemplate.project_type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.offerTemplate, "project_type_id", $$v)
                        },
                        expression: "offerTemplate.project_type_id"
                      }
                    },
                    _vm._l(_vm.projectTypeArr, function(item, key) {
                      return _c(
                        "el-option",
                        { key: key, attrs: { label: item, value: key } },
                        [_vm._v(_vm._s(item) + "\n                        ")]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Schwierigkeitsgrad", prop: "difficulty" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Bitte wählen" },
                      model: {
                        value: _vm.offerTemplate.difficulty,
                        callback: function($$v) {
                          _vm.$set(_vm.offerTemplate, "difficulty", $$v)
                        },
                        expression: "offerTemplate.difficulty"
                      }
                    },
                    _vm._l(_vm.projectDifficultyArr, function(item, key) {
                      return _c("el-option", {
                        key: key,
                        attrs: { label: item, value: key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Dienstleister Preis" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.offerTemplate.service_price,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplate, "service_price", $$v)
                      },
                      expression: "offerTemplate.service_price"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Bilder pro Stunde" } },
                [
                  _c("el-input-number", {
                    attrs: { step: 1, min: 1 },
                    model: {
                      value: _vm.offerTemplate.image_per_hour,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplate, "image_per_hour", $$v)
                      },
                      expression: "offerTemplate.image_per_hour"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Geplante Minuten außerhalb der Fotografie" }
                },
                [
                  _c("el-input-number", {
                    attrs: { step: 15, min: 15 },
                    model: {
                      value: _vm.offerTemplate.init_time_min,
                      callback: function($$v) {
                        _vm.$set(_vm.offerTemplate, "init_time_min", $$v)
                      },
                      expression: "offerTemplate.init_time_min"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-9" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Texte hinzufügen" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              placeholder: "Text hinzufügen"
                            },
                            model: {
                              value: _vm.currentTemplatePartId,
                              callback: function($$v) {
                                _vm.currentTemplatePartId = $$v
                              },
                              expression: "currentTemplatePartId"
                            }
                          },
                          _vm._l(_vm.offerTemplateParts, function(
                            offerTemplatePart
                          ) {
                            return _c("el-option", {
                              key: offerTemplatePart.id,
                              attrs: {
                                label: offerTemplatePart.name,
                                value: offerTemplatePart.id
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.addtemplatePart()
                          }
                        }
                      },
                      [_vm._v("Hinzufügen")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4 mb-4" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "offer-pdf-prev__container" }, [
                    _c(
                      "div",
                      { staticClass: "offer-pdf-prev" },
                      [
                        _c("h1", { staticClass: "offer-pdf-prev__headline" }, [
                          _vm._v("Angebot")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.offerTemplate.templateParts, function(
                          offerTemplatePartIndex,
                          index
                        ) {
                          return _c("offer-template-part", {
                            key:
                              "of-tpl-part-" +
                              offerTemplatePartIndex[0].id +
                              "#" +
                              index,
                            attrs: {
                              "offer-template-part": offerTemplatePartIndex[0]
                            },
                            on: { deleteElement: _vm.deleteElement }
                          })
                        })
                      ],
                      2
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("offerTemplate")
                    }
                  }
                },
                [_vm._v("Speichern")]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                    Neue Angebotsvorlage\n                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }